import React, { PropTypes } from "react";
import Helmet from "react-helmet";
import ReactGA from "react-ga";
import ClothingSizes from "./AvailableSizes/ClothingContainer";
import CarSeatsSizes from "./AvailableSizes/CarSeatsContainer";
import MainForm from "./MainForm";
import { Button, ButtonGroup } from "react-bootstrap";
import clothingBrands from "../data/clothing-brands";
import carSeatBrands from "../data/car-seat-brands";
import throttle from "react-throttle-render";

const ThrottledClothingSizes = throttle(500)(ClothingSizes);
const ThrottledCarSeatsSizes = throttle(500)(CarSeatsSizes);

class Home extends React.Component {
  constructor(props){
    super(props);
    this.showCarSeats = this.showCarSeats.bind(this);
    this.showClothingBrands = this.showClothingBrands.bind(this);
  }

  showCarSeats() {
    this.props.toggleCarSeats(true);
    this.props.toggleClothingBrands(false);
    ReactGA.event({
      category: "App View",
      action: "Changed",
      label: "Car Seats",
    });
  }

  showClothingBrands() {
    this.props.toggleCarSeats(false);
    this.props.toggleClothingBrands(true);
    ReactGA.event({
      category: "App View",
      action: "Changed",
      label: "Clothing",
    });
  }

  render() {
    return(
      <div>
        <Helmet title="Fit My Kid Clothing Size Finder" />
        <MainForm height={this.props.height}
          changeHeight={this.props.changeHeight}
          weight={this.props.weight}
          changeWeight={this.props.changeWeight}
          showAlert={this.props.alert}
          dismissAlert={this.props.dismissAlert}
        />

        <div className="container">
          <div className="text-center">
            <ButtonGroup>
              <Button onClick={this.showCarSeats} active={this.props.showCarSeats}>Car Seats</Button>
              <Button onClick={this.showClothingBrands} active={this.props.showClothingBrands}>Clothing</Button>
            </ButtonGroup>
          </div>
        </div>

        <ThrottledCarSeatsSizes allBrands={carSeatBrands}
          selectedBrands={this.props.selectedCarSeatBrands}
          height={this.props.height}
          weight={this.props.weight}
          gender={this.props.gender}
          isAffixed={true}
          container={this.parent}
          display={this.props.showCarSeats}/>

        <ThrottledClothingSizes allBrands={clothingBrands}
          selectedBrands={this.props.selectedClothingBrands}
          height={this.props.height}
          weight={this.props.weight}
          gender={this.props.gender}
          isAffixed={false}
          additionalInfo="current sizes: Preemie to 5T"
          display={this.props.showClothingBrands}/>
      </div>
    );
  }
}

Home.propTypes = {
  changeHeight: PropTypes.func,
  toggleCarSeats: PropTypes.func,
  toggleClothingBrands: PropTypes.func,
  height: PropTypes.number,
  weight: PropTypes.number,
  changeWeight: PropTypes.func,
  alert: PropTypes.bool,
  dismissAlert: PropTypes.func,
  showCarSeats: PropTypes.bool,
  showClothingBrands: PropTypes.bool,
  selectedCarSeatBrands: PropTypes.object,
  gender: PropTypes.string,
  selectedClothingBrands: PropTypes.object,

};

export default Home;



/** WEBPACK FOOTER **
 ** ./src/components/Home.js
 **/